const ns = '[SVG Transform] ';

export const SET_MATRIX = `${ns}set transform matrix`;
export const SET_MATRIX_INITIALIZED = `${ns}set transform matrix initialized`;
